import config from "../config";

const getUrl = (path: string, filename: string) => {

    //const host = `${process.env.REACT_APP_HOST}`;

    const host = `${config.REACT_APP_API_HOST}`;

    const url = `${host}/files/${path}/${filename}`;

    return url;
}
export default  getUrl;